











import Vue from 'vue'

/**
 * ? アイコン & ツールチップ コンポーネント
 */
export default Vue.extend({
  name: 'HelperTooltip',
  data() {
    return {
      visible: false,
    }
  },
  mounted() {
    window.addEventListener('click', this.onOuterClick);
  },
  beforeMount() {
    window.removeEventListener('click', this.onOuterClick);
  }, 
  methods: {
    onOuterClick(event: MouseEvent) {
      if(!this.visible){
        return;
      }
      
      // const ref = this.$refs.tooltipRef as HTMLDivElement;
      if(event.target instanceof Node){ 
      //if(event.target instanceof Node && !ref.contains(event.target)){ 
        // ツールチップ外をクリックで非表示
        this.visible = false;
      }
    },
  }
})
